<template>
  <div class="sub-report-list"
       :class="{ short: !expand }">
    <ul :style="{ height: (reportsList.length * 31 + 1) + 'px' }">
      <li v-for="(report, index) in reportsList"
          :key="report.id">
        <dl>
          <dt class="index">
            {{ reportsList.length - index }} / {{ reportsList.length }}
          </dt>
          <dd class="date">{{ report.runAt | yymmddhhmm }}</dd>
<!--          <dd class="count">-->
<!--            <span>Error {{ report.errorCount }} /</span>-->
<!--            {{ report.passCount + report.errorCount }}-->
<!--          </dd>-->
          <dd class="button">
            <router-link :to="{ name: 'Report', params: { id: report.id } }"
                         target="_blank">View</router-link>
          </dd>
        </dl>
      </li>
    </ul>
    <div class="show-more"
         v-if="reportsList.length > 1">
      <button @click="toggleExpand">
        <i class="icon icon--dropdown"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportList',
  props: ['reports'],
  computed: {
    reportsList () {
      return this.reports.slice().reverse()
    }
  },
  data () {
    return {
      expand: false
    }
  },
  methods: {
    toggleExpand () {
      this.expand = !this.expand
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-report-list {
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.06), 0 0 0 1px #e4de16;
  background-color: #fffc95;
  padding: 1px 1px 2px 1px;
  margin-bottom: 5px;

  ul {
    transition: height 0.3s ease;
    overflow: hidden;
  }

  dl {
    margin: 7px 7px 7px 15px;
    dt,
    dd {
      display: inline-block;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.75);
      font-weight: 300;
      margin-top: -2px;

      &.index {

      }

      &.date {
        padding: 0 12px 0 15px;
        font-size: 14px;
      }

      &.count {
        font-weight: 500;

        span {
          color: #ec0047;
        }
      }

      &.button {
        float: right;
        margin-top: 0;

        a {
          display: inline-block;
          font-weight: 500;
          color: #222222;
          font-size: 13px;
          padding: 2px 7px;
          border-radius: 4px;
          border: solid 1px #bcb729;
          background-color: #ffffff;
        }
      }
    }
  }

  &.short {
    ul {
      height: 38px !important;
    }

    .show-more {
      button {
        .icon {
          transform: rotate(-180deg);
        }
      }
    }
  }

  .show-more {
    text-align: center;
    padding: 3px 0;

    button {
      width: 100%;

      .icon {
        transform: rotate(0);
        transition: transform 0.3s ease;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/dashboard/ReportList.vue